import * as React from 'react';
import { LiteYoutubeEmbed } from 'react-lite-yt-embed';
import { TEST_ID } from "../../../../../constants";
import { IframeContainer } from "./HeroAndHighlights.styles";

const YouTubeIframe = ({
  youtubeId
}) =>
/*#__PURE__*/
// Extra div is here is necessary for intrinsic aspect ratio to work
React.createElement("div", null, /*#__PURE__*/React.createElement(IframeContainer, {
  "data-testid": TEST_ID.OVERVIEW_TAB_YOUTUBE_IFRAME
}, /*#__PURE__*/React.createElement(LiteYoutubeEmbed, {
  id: youtubeId,
  mobileResolution: "hqdefault",
  desktopResolution: "hqdefault"
})));

export default YouTubeIframe;